import { LANGUAGE_CODES, LANGUAGE_EXCEPTIONS } from './languageCodes';
import { getExampleNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';

export const getPhoneCountry = languageCode => LANGUAGE_EXCEPTIONS[languageCode]?.phoneCountry || languageCode;

export const getPhonePlaceholder = countryCode => {
    try {
        const { number } = getExampleNumber(countryCode.toUpperCase(), examples);

        const parsedNumber = parsePhoneNumberFromString(number, countryCode.toUpperCase(), examples);

        return parsedNumber ? parsedNumber.formatInternational() : '+1 (000) 000-0000';
    } catch (error) {
        return '+1 (000) 000-0000';
    }
};

export const phonePlaceholders = Object.values(LANGUAGE_CODES).reduce((acc, languageCode) => {
    const countryCode = getPhoneCountry(languageCode);
    acc[languageCode] = getPhonePlaceholder(countryCode);
    return acc;
}, {});
